import React from "react";

import { getBaseSizeByType, getColorFilter, getCountryInfo, } from "../../utils/mapUtils";
import {  TargetFOETypes } from "../../config/types";
import FlightMarkerItem from "./FlightMarkerItem";
import { Polyline } from "react-leaflet";

// Simple deterministic color generator (based on target number)
const getColorFromTgtNum = (tgtNum) => {
  if (!tgtNum && tgtNum !== 0) return "#E74C3C"; // default red

  // Create a repeatable color hue based on number
  const hue = (tgtNum * 47) % 360; // spread out hues
  return `hsl(${hue}, 80%, 50%)`;
};

const FlightMarker = ({ 
  groupedTargets, 
  scale, 
  showNumberMode, 
  speedUnit,
  currentTime, 
  selectedTargetId, 
  setSelectedTargetId, 
  showFlag,
  foeFilters,
 }) => {
 
  return (
    <>
      {
        Object.entries(groupedTargets).map(([key,targets])=>{
          const target = targets[targets.length - 1];

          if (target?.merged === true) {
            return null;
          }

          const points = target?.spline_points;
          if (!Array.isArray(points))
            return null;

          const validSplinePoints = points.filter(
            p => p && p.latitude != null && p.longitude != null
          );

          if (validSplinePoints.length === 0)
            return null;

          const last = validSplinePoints[validSplinePoints.length - 1];

          const position = [ last.latitude, last.longitude ];

          const isImportant = target.set_off === 0x55;
          let opacity = 1;

          if (!isImportant)
          {
            const elapsed = currentTime - new Date(target.modifiedAt).getTime();

            opacity = 1 - elapsed / (1000 * 60 * 8);

            if(opacity < 0.1)
              opacity = 0.1;
          }

          let address = target.address;

          if (address === 2124415080 || address >= 0xFFFFFF)
          {
            address = null;
          }

          const country = getCountryInfo(address);
          if(country && country.iso === "xx") {
            country.iso = target.countryISO?.toLowerCase() || "xx";
          }

          const colorFilter = getColorFilter(
            country?.iso === "tz" ? TargetFOETypes.FRIENDLY : target.foe, 
            target.set_off, 
            foeFilters
          );

          const size = getBaseSizeByType(target.type) * scale;

           // Extract TGT_NUM safely
          const tgtNum = target?.relatedTargets?.[0]?.TGT_NUM;
          const color = isImportant ? "#FF0000" : getColorFromTgtNum(tgtNum);
          const weight = isImportant
            ? (selectedTargetId === target?._id ? 1.8 : 1.3)
            : (selectedTargetId === target?._id ? 1.0 : 0.6);

          const dashArray = isImportant ? null : "4 6";
          
          return (
            <React.Fragment key={key}>
              <Polyline
                positions={validSplinePoints.map((p) => [p.latitude, p.longitude])}
                pathOptions={{
                  color,
                  weight,
                  dashArray,
                  opacity,
                }}
              />

              <FlightMarkerItem
                target={target}
                position={position}
                size={size}
                opacity={opacity}
                speedUnit={speedUnit}
                colorFilter={colorFilter}
                showFlag={showFlag}
                showNumberMode={showNumberMode}
                setSelectedTargetId={setSelectedTargetId}
              />
            </React.Fragment>
          );
        })
      }
    </>
  );
};

export default FlightMarker;